import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../../shared-components/TextField/TextField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';

const LOCALE_PREFIX = 'US/pages/PersonalInformationPage/Ssn';

// In order to match the existing CAPE validation, we are not restricting the user from typing non numeric characters
//instead we would validate that using the regex as HTML5 pattern attribute seems to be ignored by react.
export const isValidSSN = (msg) => (value) => {
    const pattern = /^(?!0{4})[0-9]{4}$/;
    if (pattern.test(value)) {
        return;
    } else {
        return {
            msg,
            className: 'hasError'
        };
    }
};

export class SSN extends Component {
    static propTypes = {
        intl: intlShape.isRequired
    };

    render() {
        const { intl } = this.props;

        return (
            <Field
                id="national-id-short"
                name="nationalId"
                type="tel"
                component={TextField}
                mask="9999"
                autoComplete="disabled"
                autoCorrect="off"
                autoCapitalize="off"
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.ssn-label`})}
                validate={[
                    isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.ssn-empty`})),
                    isValidSSN(intl.formatMessage({id: `${LOCALE_PREFIX}.ssn-invalid`}))
                ]}
                toolTip={intl.formatMessage({id: `${LOCALE_PREFIX}.ssn-tooltip`})}
            />
        );
    }
}

export default injectIntl(SSN);
